module.exports = __webpack_public_path__ + "static/img/016.da47ff1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/datav-headquarters/016.png
// module id = YibK
// module chunks = 1